<template>
  <div class="accounts-mobile-filters-row">
    <ui-search-input
      class="accounts-mobile-filters-row__search"
      size="small"
      placeholder="Search"
      :value="searchValue"
      @input="handleSearchInput"
      @clear="handleSearchInput" />

    <button
      class="button accounts-mobile-filters-row__show-filters-button"
      @click="$emit('on-filters-open')">
      <img
        class="accounts-mobile-filters-row__show-filters-button-icon"
        src="/images/icons/filter.svg"
        alt="Filters"
        width="16"
        height="16">
      Filters
    </button>
  </div>
</template>

<script>
import UiSearchInput from 'Components/ui/Input/UiSearchInput.vue';
import { _debounce as debounce } from 'Root/helpers/tools';

export default {
  name: 'AccountsMobileFiltersRow',
  components: { UiSearchInput },

  computed: {
    searchValue() {
      const activePreset = this.accountsPresets?.find((preset) => preset.id === +this.$route.query?.preset_id);

      if (activePreset?.params?.q) {
        return activePreset.params.q;
      }

      return this.$route.query?.q || '';
    },
  },

  methods: {
    // eslint-disable-next-line func-names
    handleSearchInput: debounce(function (value) {
      this.$emit('search', value);
    }, 1000),
  },
};
</script>

<style scoped lang="scss">
.accounts-mobile-filters-row {
  display: flex;
  align-items: center;
  gap: 16px;
}

.accounts-mobile-filters-row__search {
  width: 100%;
}

/deep/ .ui-search-input {
  color: $color--basic-light-gray;
  background-color: $color--basic-dark-gray;
  opacity: 1;

  .ui-search-input__input {
    width: 100%;
  }
}

.accounts-mobile-filters-row__show-filters-button {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  gap: 8px;
  width: fit-content;
  font-size: 13px;
  padding: 12px;
  background: linear-gradient(90deg, $color--basic-purple, $color--basic-blue);
}

.accounts-mobile-filters-row__show-filters-button-icon {
  width: 16px;
  height: 16px;
}
</style>
